/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectAllSubEnterprises = (state: { subEnterprise: any }) => state.subEnterprise.subEnterprises;
export const selectAllFilteredSubEnterprises = (state: { subEnterprise: any; }) => state.subEnterprise.filteredSubEnterprises;
export const selectSelectedSubEnterprise = (state: { subEnterprise: any }) => state.subEnterprise.selectedSubEnterprise;
export const selectNoSubEnterprise = (state: { subEnterprise: any }) => state.subEnterprise.noSubEnterprise;
